<script lang="ts">
  import {recap} from '@/store';
  import {FontFamilies} from '@/types/metadata';
  import {events} from '../RemotionElements/Util';

  function changeFont(index: number) {
    recap.update(value => {
      const composition = value.composition;
      for (let i = 0; i < composition.length; i++) {
        const element = composition[i];
        if (element.type === 'subtitle-element' && element.properties) {
          element.properties.fontFamily = FontFamilies[index];
          composition[i] = element;
        }
      }
      value.composition = composition;
      dispatchEvent(new Event(events.compositionUpdate));
      return value;
    });
  }

  function closeSideBarPopup() {
    dispatchEvent(new Event(events.sideBarPopUpClose));
  }
</script>

<div class="h-full w-full overflow-auto px-2">
  <div class="flex w-full items-center justify-between p-3">
    <h1 class="text-xl font-bold">Google Fonts</h1>
    <button on:click={closeSideBarPopup}>
      <i class="fa-solid fa-xmark text-black"></i>
    </button>
  </div>
  <div class="grid h-full gap-1">
    {#each FontFamilies as font, i}
      <button on:click={() => changeFont(i)} class="h-12 w-full rounded-lg border" style="font-family: {font};">
        {font}
      </button>
    {/each}
  </div>
</div>
